/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  TextField,
} from "@mui/material";
import { TransitionProps } from "notistack";
import { useNotification } from "../../context/notification-provider";
import { addJunkValue } from "./service";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface AddJunkValueDialogProps {
  open: boolean;
  onClose: () => void;
}

const AddJunkValueDialog: React.FC<AddJunkValueDialogProps> = ({
  open,
  onClose,
}) => {
  const [junkValue, setJunkValue] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const { showNotification } = useNotification();

  const handleSubmit = async () => {
    if (!junkValue.trim()) return;

    setIsSubmitting(true);
    try {
      await addJunkValue({
        value: junkValue.trim(),
      });
      showNotification({
        message: "Junk value added successfully.",
        severity: "success",
        duration: 3000,
      });
      setJunkValue("");
      onClose();
    } catch (err) {
      showNotification({
        message: `Failed to add junk value. Reason: ${(err as Error).message}`,
        severity: "error",
        duration: 3000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slots={{ transition: Transition }}
    >
      <DialogTitle sx={{ borderBottom: 2, mb: 2, borderColor: "divider" }}>
        Add Junk Value
      </DialogTitle>

      <DialogContent sx={{ pb: 0 }}>
        <Box sx={{ mb: 2 }}>
          Please enter the <b>junk value</b> you want to add.
        </Box>
        <TextField
          label="Junk Value"
          value={junkValue}
          onChange={(e) => setJunkValue(e.target.value)}
          fullWidth
          size="small"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!junkValue.trim() || isSubmitting}
        >
          Add Junk Value
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddJunkValueDialog;
